/**
 * External dependencies
 */
import classnames from 'classnames';

import {
	SortableContainer,
	SortableElement,
	SortableHandle
} from 'react-sortable-hoc';

/**
 * WordPress dependencies
 */

import {
	__,
	sprintf
} from '@wordpress/i18n';


import {
	Button,
	TextControl,
	SelectControl,
	ToggleControl,
	
} from '@wordpress/components';
import {GroupControl} from '@vayu-blocks';


import {
    Fragment,
    useState
} from '@wordpress/element';

import {VayuBlocksDimensions, VayuBlocksBackground, VayuBlocksTypography, VayuBlocksBorder} from '@vayu-blocks';

const DragHandle = SortableHandle( () => {
	return (
		<div className="th-sortable-handle" tabIndex="0">
			<span></span>
		</div>
	);
});

const fieldMapping = {
	image: 'displayFeaturedImage',
	category: 'displayCategory',
	title: 'displayTitle',
	price: 'displayPrice',
    rating: 'displayRating',
    button: 'displayButton',
	description: 'displayDescription'
};

export const SortableItem = ({
	attributes,
	setAttributes,
	template,
	disabled
}) => {
	
	const [ isOpen, setOpen ] = useState( false );
	const isCustomMeta = template?.startsWith( 'custom_' );
	const customMeta = attributes?.customMetas?.filter( ({ id }) =>  id === template )?.pop();

	const templateLookUp = {
		image: attributes.displayFeaturedImage,
		category:attributes.displayCategory,
		title: attributes.displayTitle,
        price: attributes.displayPrice,
        rating:attributes.displayRating,
		button:attributes.displayButton
	};

	const toggleField = fieldName => {
		const field = fieldMapping[ fieldName ] || fieldName;
		setAttributes({ [field]: ! attributes[ field ] });
	};

	const setAttributesCustomMeta = attr => {
		const newMeta = { ...customMeta, ...attr };
		setAttributes({
			customMetas: attributes.customMetas.map( currentMeta => {
				if ( currentMeta.id === customMeta.id ) {
					return newMeta;
				}
				return currentMeta;
			})
		});
	};

	const startCase = (str) => {
		if (typeof str !== 'string') {
		  throw new Error('Input must be a string');
		}
	  
		return str
		  .replace(/_/g, ' ') // Replace underscores with spaces
		  .replace(/(?:^|\s)\S/g, (match) => match.toUpperCase()); // Capitalize first letter of each word
	  };
	const toLower = (str) => {
		if (typeof str !== 'string') {
		  throw new Error('Input must be a string');
		}
	  
		return str.toLowerCase();
	  };  

	const label = ! isCustomMeta ? startCase( toLower( template ) ) : customMeta;
	const canEdit = templateLookUp[ template ] || customMeta?.display;
	const icon = canEdit ? 'visibility' : 'hidden';

	/* translators: %s Label */
	let message = sprintf( __( 'Display %s', 'vayu-blocks' ), label );
	if ( canEdit ) {

		/* translators: %s Label */
		message = sprintf( __( 'Hide %s', 'vayu-blocks' ), label );
	}


	return (
		<div
			className={ classnames(
				'th-sortable-item-area',
				`th-sortable-item-area-${ template }`
			) }
		>
			<div
				className={ classnames(
					'th-sortable-item',
					{
						'disabled': disabled,
						'hidden': ! canEdit,
						'editable': canEdit
					}
				) }
			>
				{ ! disabled && <DragHandle /> }

				<div className="th-sortable-label">
					{ label }
				</div>

				{ canEdit && (
					<Button
						icon={ isOpen ? 'arrow-up-alt2' : 'arrow-down-alt2' }
						label={ isOpen ? __( 'Close Settings', 'vayu-blocks' ) : __( 'Open Settings', 'vayu-blocks' ) }
						showTooltip={ true }
						className="th-sortable-button"
						onClick={ () => setOpen( ! isOpen ) }
					/>
				) }

				<Button
					icon={ icon }
					label={ message }
					showTooltip={ true }
					className="th-sortable-button"
					onClick={ () => {
						if ( isCustomMeta ) {
							setAttributesCustomMeta({ display: ! customMeta.display });
						} else {
							toggleField( template );
						}
						setOpen( false );
					} }
				/>
			</div>

			{ canEdit &&  (
				<div
					className={ classnames(
						'th-sortable-control-area',
						{ 'opened': isOpen && canEdit }
					) }
				    >
					{ ( 'image' === template ) && (
						<Fragment >
							
							{/* <SelectControl 
								label={ __( 'Image Size', 'vayu-blocks' ) }
								value={ attributes.prdImage }
								options={ [
									{ label:  __( 'woocommerce_thumbnail', 'vayu-blocks' ), value: 'woocommerce_thumbnail' },
									{ label: __( 'woocommerce_single', 'vayu-blocks' ), value: 'woocommerce_single' },
									{ label: __( 'woocommerce_gallery_thumbnail', 'vayu-blocks' ), value: 'woocommerce_gallery_thumbnail' },
								    
								] }
								onChange={ e => setAttributes({ prdImage: e }) }
							/> */}

								
                                <SelectControl 
								label={ __( 'Image Hover Effect', 'vayu-blocks' ) }
								value={ attributes.imageStyle }
								options={ [
									{ label:  __( 'Default', 'vayu-blocks' ), value: 'default' },
									{ label: __( 'ZoomIn', 'vayu-blocks' ), value: 'zoomin' },
									{ label: __( 'SwapIn', 'vayu-blocks' ), value: 'swapin' },
									{ label: __( 'FadeIn', 'vayu-blocks' ), value: 'fadein' },
								    
								] }
								onChange={ e => setAttributes({ imageStyle: e }) }
							  />

							  
							 {/* <ToggleControl
								label={ __( 'Quick View', 'vayu-blocks' ) }
								checked={ attributes.showView }
								onChange={ showView => setAttributes({ showView }) }
							 /> */}

						</Fragment>
					) }

                   { ( 'category' === template ) && (
						<Fragment >
							
							<VayuBlocksTypography
								value={attributes.catTypography}
								onChange={(newValues) => {setAttributes({catTypography:newValues})}}
							/>

							<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Color',
																				key:'catTxtColor',
																				value:attributes.catTxtColor
													
																			},
																			{
																				active: ['color'],
																				label: 'Hover',
																				key:'catTxtColorHvr',
																				value:attributes.catTxtColorHvr
																			},
																			
																		]}
								/>
							
						</Fragment>
					) }

                    { ( 'title' === template ) && (
						<Fragment >
							
                             <GroupControl
							           label={__( 'Tag', 'vayu-blocks' )}
                                        value={ attributes.prouctTitleTag }
                                        onChange={ prouctTitleTag => setAttributes({ prouctTitleTag })  }
										options={[
											{
												
												label: __( 'H2', 'vayu-blocks' ),
												value: 'h2'
											},
											{
												
												label: __( 'H3', 'vayu-blocks' ),
												value: 'h3'
											},
                                            {
												
												label: __( 'H4', 'vayu-blocks' ),
												value: 'h4'
											},
                                            {
												
												label: __( 'H5', 'vayu-blocks' ),
												value: 'h5'
											},
                                            {
												
												label: __( 'H6', 'vayu-blocks' ),
												value: 'h6'
											}
										]}
										
										
									/>

                            <VayuBlocksTypography
								value={attributes.titleTypography}
								onChange={(newValues) => {setAttributes({titleTypography:newValues})}}
							/>
							<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Color',
																				key:'productTitleColor',
																				value:attributes.productTitleColor
													
																			},
																			{
																				active: ['color'],
																				label: 'Hover',
																				key:'productTitleColorHvr',
																				value:attributes.productTitleColorHvr
																			},
																			
																		]}
								/>

						  
						</Fragment>
					) }

					{ ( 'price' === template ) && (
						<Fragment>
							
							<VayuBlocksTypography
								value={attributes.priceTypography}
								onChange={(newValues) => {setAttributes({priceTypography:newValues})}}
							/>

<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Color',
																				key:'PriceColor',
																				value:attributes.PriceColor
													
																			},
																			{
																				active: ['color'],
																				label: 'Hover',
																				key:'priceColorHvr',
																				value:attributes.priceColorHvr
																			},
																			
																		]}
								/>
						
						</Fragment>
					) }

					{ ( 'rating' === template ) && (
						<Fragment >
							<ToggleControl
								label={ __( 'Show Rating', 'vayu-blocks' ) }
								checked={ attributes.hideRating }
								onChange={ hideRating => setAttributes({hideRating}) }
							 />
							 <VayuBlocksTypography
								value={attributes.ratingTypography}
								onChange={(newValues) => {setAttributes({ratingTypography:newValues})}}
							/>

<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Color',
																				key:'RatingColor',
																				value:attributes.RatingColor
													
																			},
																			{
																				active: ['color'],
																				label: 'Hover',
																				key:'ratingColorHvr',
																				value:attributes.ratingColorHvr
																			},
																			
																		]}
								/>
							
						</Fragment>
					) }

                    { ( 'button' === template ) && (
						<Fragment >
						<VayuBlocksTypography
							value={attributes.buttonTypography}
							onChange={(newValues) => {setAttributes({buttonTypography:newValues})}}
						/>
						<VayuBlocksBackground
									onChange={(key,value)=>setAttributes({[key]:value})}
										colorPanel = {[
																			{
																				active: ['color'],
																				label: 'Color',
																				key:'buttonTxtClr',
																				value:attributes.buttonTxtClr
													
																			},
																			{
																				active: ['color'],
																				label: 'Hover',
																				key:'buttonTxtClrHvr',
																				value:attributes.buttonTxtClrHvr
																			},
																			{
																				active: ['gradient'],
																				label: 'Background',
																				key:'buttonBgClr',
																				value:attributes.buttonBgClr
													
																			},
																			{
																				active: ['gradient'],
																				label: 'Background Hover',
																				key:'buttonBgClrHvr',
																				value:attributes.buttonBgClrHvr
																			},
																			
																		]}
								/>
						
							<>
                <VayuBlocksBorder 
						onChange={(key,value)=>setAttributes({[key]:value})}
						border={{key:'buttonBorder',value:attributes.buttonBorder}}
						borderRadius={{key:'buttonRadius',value:attributes.buttonRadius}}
						dropShadow = {{key:'buttonShadow',value:attributes.buttonShadow}}
				/>
				</>
                 <VayuBlocksDimensions  
							onChange={(key,value)=>setAttributes({[key]:value})}
							label={{
								panel: __('Button Spacing', 'vayu-blocks'),
							}}
							dimensions={{
							padding: { key: 'buttonSpacing', value: attributes.buttonSpacing }
							}}
							/>
						</Fragment>
					) }

				</div>
			) }
		</div>
	);
};

const SortableItemContainer = SortableElement( ({
	attributes,
	setAttributes,
	template,
	disabled
}) => {
	return (
		<SortableItem
			attributes={ attributes }
			setAttributes={ setAttributes }
			template={ template }
			disabled={ disabled }
		/>
	);
});

export const SortableList = SortableContainer( ({
	attributes,
	setAttributes
}) => {
	return (
		<div>
			{ attributes?.template
				?.filter( template => {
					if ( template?.startsWith( 'custom_' ) && ( window?.acf === undefined ) ) {
						return false;
					}
					return true;
				})
				.map( ( template, index ) => (
					<SortableItemContainer
						key={ `item-${ template }` }
						index={ index }
						attributes={ attributes }
						setAttributes={ setAttributes }
						template={ template }
					/>
				) ) }
		</div>
	);
});